module.exports = __webpack_public_path__ + "static/media/default.26002ee6.jpg";